import './faq.scss'
import React from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button
} from '@material-ui/core'
import { ExpandMore } from '@material-ui/icons'
import QueryWrapper from 'components/querywrapper'
import * as qs from 'qs'
import { useFetchPage, useLocale } from 'hooks'
import { Link } from 'react-router-dom'

const { REACT_APP_STRAPI_API_URL } = process.env

function Faq() {
  const { locale } = useLocale()

  const query = qs.stringify({
    populate: '*',
    locale: [locale]
  })
  const fetcher = () =>
    fetch(`${REACT_APP_STRAPI_API_URL}/api/avax-faqpage?${query}`).then(res =>
      res.json()
    )
  const { data: faqPage, isLoading, isError } = useFetchPage(
    ['/api/faqpage', locale],
    fetcher
  )

  return (
    <QueryWrapper loading={isLoading} error={isError}>
      <div className="faqboxwrap">
        <div className="faqPage">
          {faqPage?.Faqs?.map(faq => (
            <Accordion key={faq.id}>
              <AccordionSummary
                expandIcon={<ExpandMore className="accordion-icon" />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <h1>{faq.question}</h1>
              </AccordionSummary>
              <AccordionDetails>
                <p>{faq.answer}</p>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
        <div className="askQuestion">
          <h2>{faqPage?.AskQuestionText}</h2>
          <Link to="/contact">
            <Button className="btnAskQuestion">{faqPage?.button.title}</Button>
          </Link>
        </div>
      </div>
    </QueryWrapper>
  )
}

export default Faq
